import React from 'react'

export default function About() {
  return (
    <div className="main-cover about">
      <div className="container">
        <div className="bnk-cvr">
          <div className="bank-cover">
            <div className="container">
              <div className="col-md-12">
                <div className="header">
                  <div className="title-wth title-name">ABOUT US</div>
                </div>
              </div>
              <div className="about-cover">
                <div className="row">
                  <div className="col-md-12">
                    <p>coming soon...</p>
                  </div>
                  <div className="col-md-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

